import { ICalculatorMcfValues } from '../../../types/features/calculator';

export type TUserInputForAnalytics = Record<string, string | number | null>;

/** Разметка (Confluence 1427485081, строки 26-29) фиксирует набор полей userInput, поэтому собираем
    его белым списком, а не пробросом значений калькулятора: микрофронт присылает и свои поля
    (selectedRegion), которых в разметке нет. Регион в разметке зовётся region, в калькуляторе —
    regionId. lifeInsurance не отправляем: на лендинге он не выбирается и калькулятор его не даёт. */
export const mapUserInputForAnalytics = (userInput: ICalculatorMcfValues): TUserInputForAnalytics => ({
  region: userInput.regionId ?? null,
  objectCost: userInput.objectCost ?? null,
  downPayment: userInput.downPayment ?? null,
  realEstateType: userInput.realEstateType ?? null,
  objectType: userInput.objectType ?? null,
  benefitProgram: userInput.benefitProgram ?? null,
  loanTerm: userInput.loanTerm ?? null,
  typeOfEmployment: userInput.typeOfEmployment ?? null,
  incomeConfirm: userInput.incomeConfirm ?? null,
  payrollBank: userInput.payrollBank ?? null,
});
